import type { PGPoint, PGRange } from '@zaptic-external/pg-plus'
import type { Nullable, UUID } from '../lib/typeHelpers.no-deps'

// TODO: This file used to be auto-generated, but no longer (https://code.zaptic.com/zaptic/zaptic/-/merge_requests/4102)
//       Looks like some of this is no longer used (and not maintained) -- can probably be removed.

export type DatabaseTable =
    | '_updates'
    | 'activity'
    | 'calendar_event'
    | 'campaign'
    | 'campaign_focus_list'
    | 'campaign_form'
    | 'campaign_team'
    | 'campaign_unit_list'
    | 'campaign_workflow'
    | 'countries'
    | 'deletion'
    | 'device'
    | 'documentation'
    | 'error'
    | 'fact_report'
    | 'fixes'
    | 'focus_list'
    | 'focus_list_items'
    | 'form'
    | 'form_location_list'
    | 'form_question'
    | 'form_question_response_option'
    | 'hive_info'
    | 'integration_events'
    | 'integration_feedback_queue'
    | 'integration_job'
    | 'invitations'
    | 'language_override'
    | 'linked_entity'
    | 'location_list'
    | 'location_list_item'
    | 'location_ownership'
    | 'locations'
    | 'log'
    | 'object_updates'
    | 'post'
    | 'post_comment'
    | 'post_content'
    | 'preference'
    | 'procedure_collaborator'
    | 'process_flow_v2'
    | 'process_flows'
    | 'reason_code'
    | 'reason_code_category'
    | 'report'
    | 'report_status'
    | 'reported_form'
    | 'reported_images'
    | 'reported_note'
    | 'resources'
    | 'schedule'
    | 'scheduled_instance'
    | 'smart_data'
    | 'smart_data_linked_entity'
    | 'smart_data_ordering'
    | 'smart_data_targets'
    | 'strings'
    | 'team_membership'
    | 'teams'
    | 'timeline_event'
    | 'trigger'
    | 'trigger_action'
    | 'trigger_and'
    | 'trigger_audit'
    | 'trigger_condition'
    | 'unit'
    | 'unit_list'
    | 'unit_list_item'
    | 'unit_list_location_list'
    | 'unit_relation'
    | 'unit_type'
    | 'unit_type_relation'
    | 'users'
    | 'workflow'
    | 'workflow_dependency'

export namespace Updates {
    export type Table = {
        date: Nullable<Date>
        name: string
    }
}
export namespace Activity {
    export enum CameraResolution {
        high = 'high',
        low = 'low',
        medium = 'medium',
    }
    export const cameraResolution: CameraResolution[] = [
        CameraResolution.high,
        CameraResolution.low,
        CameraResolution.medium,
    ]
    export enum Type {
        email = 'email',
        form = 'form',
        multi_image_capture = 'multi-image-capture',
        note = 'note',
        process_flow = 'process-flow',
        report = 'report',
        send = 'send',
        simple = 'simple',
        simple_unit = 'simple-unit',
        unit_form = 'unit-form',
    }
    export const type: Type[] = [
        Type.email,
        Type.form,
        Type.multi_image_capture,
        Type.note,
        Type.process_flow,
        Type.report,
        Type.send,
        Type.simple,
        Type.simple_unit,
        Type.unit_form,
    ]
    export type Table = {
        cameraResolution: Nullable<CameraResolution.high | CameraResolution.low | CameraResolution.medium>
        display: Nullable<never>
        id: number
        isDeleted: boolean
        lastModified: Nullable<Date>
        name: string
        options: Nullable<never>
        position: Nullable<number>
        processFlow: Nullable<number>
        type:
            | Type.email
            | Type.form
            | Type.multi_image_capture
            | Type.note
            | Type.process_flow
            | Type.report
            | Type.send
            | Type.simple
            | Type.simple_unit
            | Type.unit_form
        workflow: Nullable<number>
    }
}
export namespace CalendarEvent {
    export type Table = {
        author: number
        campaign: Nullable<number>
        createdDate: Nullable<Date>
        data: never
        editor: Nullable<number>
        endDate: Nullable<Date>
        exceptions: Nullable<never>
        id: number
        isDeleted: boolean
        lastMod: Nullable<Date>
        location: number
        recurrencePattern: Nullable<string>
        recurring: Nullable<boolean>
        series: Nullable<number>
        startDate: Nullable<Date>
        workflow: Nullable<number>
    }
}
export namespace Campaign {
    export type Table = {
        activeBetween: PGRange<Date>
        allTeams: Nullable<boolean>
        description: Nullable<string>
        id: number
        isDeleted: boolean
        lastMod: Nullable<Date>
        name: string
        tags: undefined
    }
}
export namespace CampaignFocusList {
    export type Table = {
        campaign: number
        focusList: number
    }
}
export namespace CampaignForm {
    export type Table = {
        campaign: number
        form: number
    }
}
export namespace CampaignTeam {
    export type Table = {
        campaign: number
        team: number
    }
}
export namespace CampaignUnitList {
    export type Table = {
        campaign: number
        unitList: number
    }
}
export namespace CampaignWorkflow {
    export type Table = {
        campaign: number
        workflow: number
    }
}
export namespace Countries {
    export type Table = {
        isDeleted: boolean
        name: Nullable<string>
        region: Nullable<string>
        regionId: number
    }
}
export namespace Deletion {
    export type Table = {
        entity: Nullable<string>
        id: Nullable<number>
        time: Nullable<Date>
    }
}
export namespace Device {
    export type Table = {
        currentOwner: number
        currentVersion: Nullable<string>
        deviceId: string
        lastSync: Nullable<Date>
        os: Nullable<string>
        pendingReports: Nullable<number>
    }
}
export namespace Documentation {
    export type Table = {
        category: Nullable<string>
        id: number
        issue: Nullable<number>
        name: Nullable<string>
    }
}
export namespace Error {
    export type Table = {
        endpoint: Nullable<string>
        error: Nullable<string>
        id: number
        request: Nullable<never>
        requestId: string
        serverVersion: Nullable<string>
        stack: Nullable<string>
        time: Nullable<Date>
        userEmail: Nullable<string>
        userId: Nullable<number>
    }
}
export namespace FactReport {
    export enum ActionType {
        email = 'email',
        form = 'form',
        multi_image_capture = 'multi-image-capture',
        note = 'note',
        process_flow = 'process-flow',
        report = 'report',
        send = 'send',
        simple = 'simple',
        simple_unit = 'simple-unit',
        unit_form = 'unit-form',
    }
    export const actionType: ActionType[] = [
        ActionType.email,
        ActionType.form,
        ActionType.multi_image_capture,
        ActionType.note,
        ActionType.process_flow,
        ActionType.report,
        ActionType.send,
        ActionType.simple,
        ActionType.simple_unit,
        ActionType.unit_form,
    ]
    export enum FactReportType {
        location_form = 'location-form',
        location_issue = 'location-issue',
        unit_form = 'unit-form',
        unit_issue = 'unit-issue',
    }
    export const factReportType: FactReportType[] = [
        FactReportType.location_form,
        FactReportType.location_issue,
        FactReportType.unit_form,
        FactReportType.unit_issue,
    ]
    export type Table = {
        actionType: Nullable<
            | ActionType.email
            | ActionType.form
            | ActionType.multi_image_capture
            | ActionType.note
            | ActionType.process_flow
            | ActionType.report
            | ActionType.send
            | ActionType.simple
            | ActionType.simple_unit
            | ActionType.unit_form
        >
        activity: Nullable<number>
        author: Nullable<number>
        campaign: Nullable<number>
        endDate: Nullable<Date>
        factReportType:
            | FactReportType.location_form
            | FactReportType.location_issue
            | FactReportType.unit_form
            | FactReportType.unit_issue
        fix: Nullable<number>
        fixImages: Nullable<number>
        fixNote: Nullable<number>
        form: Nullable<number>
        formGroup: Nullable<number>
        formQuestion: Nullable<number>
        formResult: Nullable<number>
        id: number
        lat: Nullable<number>
        location: Nullable<number>
        lon: Nullable<number>
        reasonCode: Nullable<number>
        reasonCodeCategory: Nullable<number>
        reasonCodeImages: Nullable<number>
        reasonCodeNote: Nullable<number>
        reasonCodeValue: Nullable<number>
        report: Nullable<number>
        startDate: Nullable<Date>
        status: number
        submittedDate: Nullable<Date>
        unit: Nullable<number>
        unitType: Nullable<number>
        workflow: Nullable<number>
    }
}
export namespace Fixes {
    export type Table = {
        authorId: Nullable<number>
        creationDate: Nullable<Date>
        editionDate: Nullable<Date>
        editorId: Nullable<number>
        fixId: number
        isDeleted: boolean
        lastModified: Nullable<Date>
        title: Nullable<string>
    }
}
export namespace FocusList {
    export type Table = {
        id: number
        lastMod: Nullable<Date>
        name: Nullable<string>
        type: Nullable<string>
    }
}
export namespace FocusListItems {
    export type Table = {
        callQuantity: number
        displayValue: Nullable<string>
        focusList: Nullable<number>
        item: Nullable<number>
        worth: Nullable<number>
    }
}
export namespace Form {
    export type Table = {
        author: Nullable<number>
        id: number
        isDeleted: boolean
        lastMod: Nullable<Date>
        name: string
        type: string
    }
}
export namespace FormLocationList {
    export type Table = {
        form: number
        lastMod: Nullable<Date>
        locationList: number
    }
}
export namespace FormQuestion {
    export enum CameraResolution {
        high = 'high',
        low = 'low',
        medium = 'medium',
    }
    export const cameraResolution: CameraResolution[] = [
        CameraResolution.high,
        CameraResolution.low,
        CameraResolution.medium,
    ]
    export enum Type {
        autocomplete = 'autocomplete',
        autocomplete_multi_select = 'autocomplete-multi-select',
        calculation = 'calculation',
        checkbox = 'checkbox',
        date = 'date',
        image = 'image',
        number = 'number',
        question = 'question',
        radio = 'radio',
        select = 'select',
        signature = 'signature',
        smart_select = 'smart-select',
        text = 'text',
        yesno = 'yesno',
    }
    export const type: Type[] = [
        Type.autocomplete,
        Type.autocomplete_multi_select,
        Type.calculation,
        Type.checkbox,
        Type.date,
        Type.image,
        Type.number,
        Type.question,
        Type.radio,
        Type.select,
        Type.signature,
        Type.smart_select,
        Type.text,
        Type.yesno,
    ]
    export type Table = {
        barcodeScannable: Nullable<boolean>
        calculation: Nullable<never>
        cameraResolution: Nullable<CameraResolution.high | CameraResolution.low | CameraResolution.medium>
        display: Nullable<never>
        endDate: Nullable<Date>
        form: Nullable<number>
        id: number
        includeTime: Nullable<boolean>
        info: Nullable<string>
        isDeleted: boolean
        label: string
        mandatory: Nullable<boolean>
        position: number
        prefill: Nullable<string>
        smartData: Nullable<never>
        startDate: Nullable<Date>
        type:
            | Type.autocomplete
            | Type.autocomplete_multi_select
            | Type.calculation
            | Type.checkbox
            | Type.date
            | Type.image
            | Type.number
            | Type.question
            | Type.radio
            | Type.select
            | Type.signature
            | Type.smart_select
            | Type.text
            | Type.yesno
        validation: Nullable<never>
    }
}
export namespace FormQuestionResponseOption {
    export type Table = {
        data: Nullable<never>
        id: number
        isDeleted: boolean
        label: string
        position: Nullable<number>
        question: Nullable<number>
    }
}
export namespace HiveInfo {
    export type Table = {
        customerId: Nullable<number>
        customerName: Nullable<string>
        databaseVer: Nullable<string>
        lastUpdate: Nullable<Date>
        serverVer: Nullable<string>
    }
}
export namespace IntegrationEvents {
    export type Table = {
        id: number
        keyName: Nullable<string>
        object: Nullable<string>
        oid: Nullable<string>
    }
}
export namespace IntegrationFeedbackQueue {
    export type Table = {
        id: number
        jobId: number
        reportId: number
    }
}
export namespace IntegrationJob {
    export enum Type {
        feedback = 'feedback',
    }
    export const type: Type[] = [Type.feedback]
    export type Table = {
        id: number
        name: string
        type: Type.feedback
    }
}
export namespace Invitations {
    export type Table = {
        author: Nullable<number>
        blob: Nullable<never>
        date: Nullable<Date>
        email: Nullable<string>
        expire: Nullable<Date>
        id: number
        status: Nullable<string>
        token: Nullable<string>
        type: Nullable<string>
        valid: Nullable<boolean>
    }
}
export namespace LanguageOverride {
    export type Table = {
        id: number
        lang: Nullable<string>
        path: string
        text: string
    }
}
export namespace LinkedEntity {
    export type Table = {
        id: number
        key: string
        location: Nullable<number>
        unit: Nullable<number>
        user: Nullable<number>
    }
}
export namespace LocationList {
    export type Table = {
        automated: boolean
        definition: Nullable<never>
        id: number
        lastMod: Nullable<Date>
        name: string
    }
}
export namespace LocationListItem {
    export type Table = {
        list: number
        location: number
    }
}
export namespace LocationOwnership {
    export type Table = {
        isAutomated: Nullable<boolean>
        lastMod: Nullable<Date>
        locationId: number
        ownershipId: number
        userId: number
    }
}
export namespace Locations {
    export type Table = {
        address1: Nullable<string>
        address2: Nullable<string>
        barcodeFormat: Nullable<string>
        country: Nullable<number>
        createdDate: Date
        foreignIds: Nullable<never>
        integrationId: Nullable<string>
        isDeleted: boolean
        lastMod: Nullable<Date>
        localId: Nullable<string>
        locationId: number
        name: Nullable<string>
        postcode: Nullable<string>
        state: Nullable<string>
        town: Nullable<string>
        type: Nullable<string>
        xCoord: Nullable<number>
        yCoord: Nullable<number>
    }
}
export namespace Log {
    export enum Operation {
        delete = 'delete',
        insert = 'insert',
        update = 'update',
    }
    export const operation: Operation[] = [Operation.delete, Operation.insert, Operation.update]
    export type Table = {
        data: Nullable<never>
        entity: string
        operation: Operation.delete | Operation.insert | Operation.update
        time: Nullable<Date>
        userId: number
    }
}
export namespace ObjectUpdates {
    export type Table = {
        lastUpdate: Nullable<Date>
        target: Nullable<string>
    }
}
export namespace Post {
    export enum LastModifiedType {
        commented = 'commented',
        created = 'created',
        deleted = 'deleted',
        updated = 'updated',
    }
    export const lastModifiedType: LastModifiedType[] = [
        LastModifiedType.commented,
        LastModifiedType.created,
        LastModifiedType.deleted,
        LastModifiedType.updated,
    ]
    export type Table = {
        createdAt: Date
        createdBy: number
        id: UUID
        isDeleted: Nullable<boolean>
        lastModifiedAt: Date
        lastModifiedBy: number
        lastModifiedType:
            | LastModifiedType.commented
            | LastModifiedType.created
            | LastModifiedType.deleted
            | LastModifiedType.updated
        location: Nullable<number>
        procedure: Nullable<number>
        serverSyncTime: Date
        unit: Nullable<number>
        workflow: Nullable<number>
    }
}
export namespace PostComment {
    export type Table = {
        createdAt: Date
        createdBy: number
        id: UUID
        isDeleted: Nullable<boolean>
        lastModifiedAt: Date
        lastModifiedBy: number
        post: UUID
        text: string
    }
}
export namespace PostContent {
    export enum ContentType {
        file = 'file',
        photo = 'photo',
        report = 'report',
        text = 'text',
        video = 'video',
        reportReference = 'reportReference',
        procedureEvent = 'procedureEvent',
        unitEvent = 'unitEvent',
        actionEvent = 'actionEvent',
    }

    export type FileContentType = ContentType.file | ContentType.photo | ContentType.video

    export const contentType: ContentType[] = [
        ContentType.file,
        ContentType.photo,
        ContentType.report,
        ContentType.text,
        ContentType.video,
        ContentType.reportReference,
        ContentType.procedureEvent,
        ContentType.unitEvent,
        ContentType.actionEvent,
    ]

    export const fileContentTypes: FileContentType[] = [ContentType.file, ContentType.photo, ContentType.video]

    export type Table = {
        contentType: ContentType.file | ContentType.photo | ContentType.report | ContentType.text | ContentType.video
        createdAt: Date
        createdBy: number
        fileSizeInBytes: Nullable<number>
        id: UUID
        mimeType: Nullable<string>
        post: UUID
        processingStatus: Nullable<string>
        report: Nullable<number>
        reportActivities: Nullable<number>
        reportWorkflowName: Nullable<string>
        text: Nullable<string>
        thumbnail: Nullable<string>
        title: Nullable<string>
        url: Nullable<string>
        reportClientId: Nullable<UUID>
        reportParentClientId: Nullable<UUID>
        procedureEvent: Nullable<number>
        unitEvent: Nullable<number>
        actionEvent: Nullable<number>
    }
}
export namespace Preference {
    export type Table = {
        data: Nullable<never>
        id: number
        type: string
    }
}
export namespace ProcedureCollaborator {
    export type Table = {
        collaborator: Nullable<number>
        procedure: Nullable<number>
    }
}
export namespace ProcessFlowV2 {
    export type Table = {
        id: number
        lastMod: Nullable<Date>
        name: string
        questions: Nullable<never>
    }
}
export namespace ProcessFlows {
    export type Table = {
        id: number
        name: Nullable<string>
        questions: Nullable<never>
        target: Nullable<number>
    }
}
export namespace ReasonCode {
    export type Table = {
        affectsKpi: Nullable<boolean>
        category: Nullable<number>
        hasValue: Nullable<boolean>
        id: number
        isDeleted: boolean
        isFixable: Nullable<boolean>
        isPositive: Nullable<boolean>
        lastMod: Nullable<Date>
        name: Nullable<string>
    }
}
export namespace ReasonCodeCategory {
    export enum AggregationType {
        average = 'average',
        total = 'total',
    }
    export const aggregationType: AggregationType[] = [AggregationType.average, AggregationType.total]
    export enum CalculationType {
        percentage = 'percentage',
        sum = 'sum',
    }
    export const calculationType: CalculationType[] = [CalculationType.percentage, CalculationType.sum]
    export type Table = {
        aggregationType: AggregationType.average | AggregationType.total
        calculationType: CalculationType.percentage | CalculationType.sum
        description: Nullable<string>
        display: Nullable<never>
        id: number
        isDeleted: boolean
        lastMod: Nullable<Date>
        name: Nullable<string>
    }
}
export namespace Report {
    export type Table = {
        answers: Nullable<never>
        author: number
        campaign: number
        clientId: UUID
        coordinates: PGPoint
        data: never
        endDate: Date
        event: number
        id: number
        isDeleted: boolean
        location: number
        scheduledInstance: Nullable<UUID>
        startDate: Date
        status: number
        submittedDate: Date
        workflow: number
    }
}
export namespace ReportStatus {
    export type Table = {
        id: number
        isActive: boolean
        isDefault: boolean
        lastMod: Nullable<Date>
        name: string
        workflow: number
    }
}
export namespace ReportedForm {
    export type Table = {
        form: Nullable<number>
        id: number
        question: Nullable<number>
        response: never
    }
}
export namespace ReportedImages {
    export type Table = {
        id: number
        imageCount: Nullable<number>
        images: never
    }
}
export namespace ReportedNote {
    export type Table = {
        id: number
        note: string
    }
}
export namespace Resources {
    export type Table = {
        id: number
        url: Nullable<string>
    }
}
export namespace Schedule {
    export enum Frequency {
        daily = 'daily',
        hourly = 'hourly',
        minutely = 'minutely',
        monthly = 'monthly',
        weekly = 'weekly',
        yearly = 'yearly',
    }
    export const frequency: Frequency[] = [
        Frequency.daily,
        Frequency.hourly,
        Frequency.minutely,
        Frequency.monthly,
        Frequency.weekly,
        Frequency.yearly,
    ]
    export enum OncePer {
        team = 'team',
        user = 'user',
    }
    export const oncePer: OncePer[] = [OncePer.team, OncePer.user]
    export type Table = {
        createdAt: Date
        createdBy: number
        dueDate: Nullable<Date>
        endDate: Nullable<Date>
        frequency: Nullable<
            | Frequency.daily
            | Frequency.hourly
            | Frequency.minutely
            | Frequency.monthly
            | Frequency.weekly
            | Frequency.yearly
        >
        id: UUID
        isDeleted: boolean
        occurrences: Nullable<number>
        oncePer: OncePer.team | OncePer.user
        procedure: number
        showOverdue: boolean
        startDate: Date
        timezone: string
        workflow: number
    }
}
export namespace ScheduledInstance {
    export type Table = {
        dueDate: Date
        id: UUID
        isDeleted: boolean
        lastModifiedAt: Date
        schedule: UUID
        startDate: Date
        subjectUnitId: Nullable<number>
        isVisibleAccordingToCondition: Nullable<boolean>
        serialId: number
    }
}
export namespace SmartData {
    export type Table = {
        date: Nullable<Date>
        id: number
        key: string
        source: string
        type: string
        value: never
    }
}
export namespace SmartDataLinkedEntity {
    export type Table = {
        entity: Nullable<number>
        sdId: Nullable<number>
    }
}
export namespace SmartDataOrdering {
    export type Table = {
        rank: Nullable<number>
        source: Nullable<string>
    }
}
export namespace SmartDataTargets {
    export type Table = {
        sdId: number
        targetId: number
    }
}
export namespace Strings {
    export type Table = {
        id: number
        lang: Nullable<string>
        lastMod: Date
        slug: Nullable<string>
        text: Nullable<string>
    }
}
export namespace TeamMembership {
    export type Table = {
        isadmin: boolean
        member: number
        team: number
    }
}
export namespace Teams {
    export type Table = {
        id: number
        name: string
    }
}
export namespace TimelineEvent {
    export enum Type {
        report = 'report',
        smartdata = 'smartdata',
        text = 'text',
    }
    export const type: Type[] = [Type.report, Type.smartdata, Type.text]
    export type Table = {
        author: number
        campaign: number
        date: Date
        id: number
        item: never
        lastMod: Nullable<Date>
        location: Nullable<number>
        type: Type.report | Type.smartdata | Type.text
    }
}
export namespace Trigger {
    export enum Type {
        cron = 'cron',
        report_status_changed = 'report-status-changed',
        report_submitted = 'report-submitted',
        all_actions_complete = 'all-actions-complete',
    }
    export const type: Type[] = [Type.cron, Type.report_status_changed, Type.report_submitted]
    export type Table = {
        cronDefinition: Nullable<string>
        id: number
        isActive: boolean
        name: string
        type: Type.cron | Type.report_status_changed | Type.report_submitted
    }
}
export namespace TriggerAction {
    export enum Type {
        email = 'email',
    }
    export const type: Type[] = [Type.email]
    export type Table = {
        emailBody: string
        emailLinkToReport: boolean
        emailRecipients: Nullable<never>
        emailSubject: string
        emailToReportAuthor: boolean
        id: number
        trigger: number
        type: Type.email
    }
}
export namespace TriggerAnd {
    export type Table = {
        id: number
        trigger: number
    }
}
export namespace TriggerAudit {
    export enum Type {
        activated = 'activated',
        created = 'created',
        deactivated = 'deactivated',
        updated = 'updated',
    }
    export const type: Type[] = [Type.activated, Type.created, Type.deactivated, Type.updated]
    export type Table = {
        at: Date
        by: number
        id: number
        trigger: number
        type: Type.activated | Type.created | Type.deactivated | Type.updated
    }
}
export namespace TriggerCondition {
    export enum Type {
        equal = 'equal',
        not_equal = 'not-equal',
    }
    export const type: Type[] = [Type.equal, Type.not_equal]
    export type Table = {
        authorMatch: Nullable<number>
        campaignMatch: Nullable<number>
        id: number
        optionQuestionMatch: Nullable<number>
        optionResponseMatch: Nullable<number>
        otherQuestionMatch: Nullable<number>
        otherResponseMatch: Nullable<string>
        reasonCodeMatch: Nullable<number>
        reportStatusMatch: Nullable<number>
        triggerAnd: number
        type: Type.equal | Type.not_equal
    }
}
export namespace Unit {
    export type Table = {
        data: Nullable<never>
        foreignIds: Nullable<never>
        id: number
        isDeleted: boolean
        lastMod: Nullable<Date>
        name: string
        type: Nullable<number>
    }
}
export namespace UnitList {
    export type Table = {
        data: Nullable<never>
        id: number
        lastMod: Nullable<Date>
        name: string
        type: Nullable<string>
        unitType: number
    }
}
export namespace UnitListItem {
    export type Table = {
        displayValues: Nullable<never>
        endDate: Nullable<Date>
        item: number
        list: number
        ordering: Nullable<number>
        startDate: Nullable<Date>
    }
}
export namespace UnitListLocationList {
    export type Table = {
        locationList: number
        unitList: number
    }
}
export namespace UnitRelation {
    export type Table = {
        child: number
        parent: number
    }
}
export namespace UnitType {
    export type Table = {
        display: Nullable<never>
        id: number
        isDeleted: boolean
        lastMod: Nullable<Date>
        name: string
        options: Nullable<never>
    }
}
export namespace UnitTypeRelation {
    export type Table = {
        child: Nullable<number>
        parent: Nullable<number>
    }
}
export namespace Users {
    export type Table = {
        email: string
        emailPreferences: never
        foreignIds: Nullable<never>
        forename: string
        isDeleted: boolean
        jobTitle: string
        language: string
        lastModified: Nullable<Date>
        lastSync: Nullable<Date>
        office: Nullable<number>
        password: Nullable<string>
        points: never
        pointsTotal: Nullable<number>
        prefs: never
        privs: never
        ssoId: Nullable<string>
        surname: string
        userId: number
        zapticStaff: boolean
    }
}
export namespace Workflow {
    export enum Type {
        guide = 'guide',
        task = 'task',
        training = 'training',
    }
    export const type: Type[] = [Type.guide, Type.task, Type.training]
    export type Table = {
        id: number
        isDeleted: boolean
        lastModified: Nullable<Date>
        name: string
        type: Type.guide | Type.task | Type.training
    }
}
export namespace WorkflowDependency {
    export type Table = {
        dependency: Nullable<number>
        entry: Nullable<number>
    }
}
